<template>
  <!-- 开票新增 -->
  <div class="invoice-add">
    <div class="billingMoney">
        <h3>开票金额</h3>
        <el-row>
            <el-col :span="8">
                <div>开票金额</div>
                <p>{{ $filters.formatMoney(dataForm.invoiceAmount)}}<span>(CNY)</span></p>
            </el-col>
            <el-col :span="8">
                <div>税率</div>
                <p>{{dataForm.taxRate ? dataForm.taxRate + '%' : ''}}</p>
            </el-col>
            <el-col :span="8">
                <div>税额</div>
                <p>{{ $filters.formatMoney(dataForm.tax)}}<span>(CNY)</span></p>
            </el-col>
        </el-row>
    </div>

    <div class="invoice-herder">
        <el-form :model="customerVo" ref="customerVo" label-position="top"  class="dataForm" :rules="rules">        
            <h3>发票抬头</h3>
            <el-form-item>
                <div class="supplierName">
                    <div class="supplier">
                        <span>*</span>
                        开票名称
                    </div>
                    <p>{{customerVo.billName}}</p>
                    <div class="name">纳税人识别号：<span>{{customerVo.taxpayerCode}}</span></div>
                </div>
            </el-form-item>
            <el-row gutter="20">
                <el-col :span="8">
                    <el-form-item label="开户银行" prop="billBank">
                        <el-input v-model="customerVo.billBank"  placeholder="请输入开户银行" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="银行账号" prop="billBankAcct">
                        <el-input v-model="customerVo.billBankAcct"  placeholder="请输入开户银行" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="联系电话" prop="billTel">
                        <el-input v-model="customerVo.billTel"  placeholder="请输入联系电话" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="开票地址" prop="billAddress">
                        <el-input v-model="customerVo.billAddress"  placeholder="请输入开票地址" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">                    
                    <el-row style="width:100%">
                        <el-form-item label="收票人及联系电话" prop="receiptInvoicePerson" class="receiptInvoiceTela">
                            <el-input v-model="customerVo.receiptInvoicePerson"  placeholder="请输入收票联系人" clearable></el-input>
                        </el-form-item>
                        
                        <el-form-item label=" " prop="receiptInvoiceTel" class="receiptInvoiceTelb"> 
                            <el-input v-model="customerVo.receiptInvoiceTel"  placeholder="请输入收票人联系电话" clearable></el-input>
                        </el-form-item>
                    </el-row>                    
                </el-col>
                <el-col :span="16"><!-- border-top-right-radius: 0; border-bottom-right-radius: 0; -->
                    <el-form-item label="收票地址" prop="receiptInvoiceAddress">
                        <el-input v-model="customerVo.receiptInvoiceAddress"  placeholder="请输入收票地址" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>

    <div class="billingMoney-table">
        <div class="title">
            <h3>开票金额</h3>
            <el-button :loading="load.btnLoading"  @click="exportFile">导出</el-button>
        </div>

        <ab-table
            class="materialTable"
            showOrder
            stripe
            indexLabel="序号"
            ref="table"
            selectionWidth="45"
            indexWidth="80"
            showMoreEdit
            widths="140"
            :column-list="columns"
            :table-list="tableData"
            :dataListLoading="isloading"
            :handleSelectionChange="handleSelectionChange"
            :headerCellClassName='must'
            :showSummary="true"
            :summary-method="(param)=>getSummaries1(param,['invoiceCount','notTaxAmount','tax','taxAmount'])"
        >
        <template #taxRate="scope">
            {{scope.row.taxRate}}%
        </template>
        </ab-table>
    </div>

    <ab-footer>
        <el-button @click="backListPage">返回</el-button>
        <!-- <el-button type="primary"  @click="handlerSubmit" :loading="load.btnLoading2">提交</el-button> -->
        <el-button type="primary"  @click="editInvoice" :loading="load.btnLoading2">提 交</el-button>
    </ab-footer>

    <!-- 签章 -->
    <ab-preview :preview="preview"  @handleClose="handleClose">
        <template #button>
            <el-button @click="preview.show = false">关 闭</el-button>
        </template>
    </ab-preview>
  </div>
</template>

<script>
export default {
    name: 'invoice-add',
    data() {
        return {
            //状态汇总
            load:{
                btnLoading:false,
                btnLoading2:false,
                btnLoading3:false,
            },
            dataForm:{},
            detailData:{},
            customerVo:{},
            columns: [
                {
                  props: "custOrderNo",
                  labels: "订单编号",
                  widths: 120,
                },
                {
                  props: "materialDesc",
                  labels: "开票名称",
                  widths: 100,
                },
                {
                  props: "model",
                  labels: "规格型号",
                  widths: 100,
                },
                {
                  props: "unitIdDesc",
                  labels: "单位",
                  widths: 100,
                },
                {
                  props: "invoiceCount",
                  labels: "数量",
                  widths: 70,
                },
                {
                  props: "notTaxAmount",
                  labels: "不含税金额",
                  widths: 100,
                  type:'money',
                  align: "right",
                },
        
                {
                  props: "tax",
                  labels: "税额",
                  widths: 100,
                  type:'money',
                  align: "right",
                },
                {
                  props: "taxAmount",
                  labels: "价税合计",
                  widths: 100,
                  type:'money',
                  align: "right",
                },
        
                {
                  props: "taxRate",
                  labels: "税率",
                  widths: 100,
                  slot:'slot',
                  align: "center",
                },
            ],
            tableData: [],
            rules:{
                billBank:[
                    { required: false, message: '请输入开户银行', trigger: 'blur'}
                ],
                bankNamber:[
                    { required: true, message: '请输入银行账号', trigger: 'blur'}
                ],
                billTel:[
                    { required: false, message: '请输入联系电话', trigger: 'blur'}
                ],
                billAddress:[
                    { required: false, message: '请输入开票地址', trigger: 'blur'}
                ],
                receiptInvoiceTel:[
                    { required: false, message: '请输入收票人联系电话', trigger: 'blur'}
                ],
                receiptInvoiceAddress:[
                    { required: false, message: '请输入收票地址', trigger: 'blur'}
                ],
                receiptInvoicePerson:[
                    { required: false, message: '请输入收票联系人', trigger: 'blur'}
                ],
            },
            preview: {
                show: false,
                isView: false,
                isFooter: true,
                fileUrl: ''
            },
            routeQuery: {}
        }
    },
    computed: {       
        menuActiveName: {
            get() {
                return this.$store.state.mainTabsActiveName
            },
            set(val) {
                this.$store.commit('updateMainTabsActiveName', val)
            },
        },
        mainTabs: {
            get() {
                return this.$store.state.mainTabs
            },
            set(val) {
                this.$store.commit('updateMainTabs', val)
            },
        },
        isEdit () {
            return this.dataForm.clientStatus != '01-1'
        }
    },
    methods:{
        //表格合计
        getSummaries1(param,value) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计';
                return;
            }
            let val= value.indexOf(column.property) != -1
            if(val){
                const values = data.map(item => Number(item[column.property]))
                sums[index]= values.reduce((prev, curr) => {
                    const value = Number(curr)
                    if (!isNaN(value)) {
                            return this.$calc.add(prev, curr)
                        } else {
                            return prev
                        }
                }, 0)
                if (column.property != 'invoiceCount') {
                    sums[index] = this.$filters.formatMoney(sums[index])
                }
            }
            });
            return sums;
        },
        //表头心号
        must(obj){
            if(['invoiceCount'].indexOf(obj.column.property) !== -1) {
                return 'must';
            }
        },
        //提交
        handlerSubmit(){
            let params = {}
            params = this.dataForm
            params.drawInvoiceEntryDtos = this.tableData
            params.customerVo= this.customerVo
            params.customerVo.billBankName= this.customerVo.billName
            this.$http({
                url: this.$adornUrl("/fms/client/drawInvoice/save"),
                method: "post",
                data: params
            }).then(({ data }) => {
                if (data.code === "C0000") {
                    // this.$emit('refresh')
                    if (data.extra) {
                        // this.$router.push({
                        //     path: '/my-signature',//我的签章
                        // })
                        this.preview.isView = true
                        this.preview.fileTitle = '销售合同'
                        this.preview.fileUrl = data.extra
                        this.preview.show = true
                    }else{
                        this.$message({type: 'success', message: '您的开票申请已收到，处理进度稍后可查看【开票状态】', offset: 380, grouping: true})
                        this.mainTabs.filter(item => item.name !== this.menuActiveName) // 删除
                        this.$router.push({
                            path: '/invoice-history',//开票记录
                        })
                    }
                } else {
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                return;
                }
            }).finally(() => {
                this.load.btnLoading2 = false
            })
            
        },
        //导出
        exportFile(){
            this.load.btnLoading=true
            let params = {}
            let excelField = this.columns.map(e => e.props);
            params.data= this.detailData.result
            params.data.mergeDtos= params.data.mergeVos
            params.data.drawInvoiceEntryDtos= params.data.drawInvoiceEntryVos
            params.data.customerVo= this.detailData.customerVo
            params.data.customerVo.billBankName= this.customerVo.billBank
            params.data.customerVo.id= null
            params.excelField= excelField
                
            this.$post("/fms/client/drawInvoice/deriveDrawInfo",params).then(({ data }) => {
                if (data && data.code === "C0000") {
                // 创建隐藏的可下载链接
                var eleLink = document.createElement("a");
                eleLink.download = "";
                eleLink.target = "_blank";
                eleLink.style.display = "none";
                // 字符内容转变成blob地址
                eleLink.href = data.message;
                // 触发点击
                document.body.appendChild(eleLink);
                eleLink.click();
                // 然后移除
                document.body.removeChild(eleLink);
                } else {
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.load.btnLoading=false
            });
        },
        //保存
        editInvoice() {
            this.load.btnLoading2=true
            this.$refs.customerVo.validate((valid) => {
                if (valid) {
                    // if((this.customerVo.billAddress + '' + this.customerVo.billTel).length > 37) {
                    //     this.$message(
                    //     {
                    //         type: 'error',
                    //         message: '因发票打印显示有限，【开票地址】和【电话】总共长度不超过37个字符，可以精简开票地址',
                    //         duration: 6000
                    //     }
                    //     )
                    //     return
                    // }
                    let data = {
                        billName: this.customerVo.billName,
                        taxpayerCode: this.customerVo.taxpayerCode,
                        billAddress: this.customerVo.billAddress,
                        billTel: this.customerVo.billTel,
                        billBankName: this.customerVo.billBank,
                        billBankAcct: this.customerVo.billBankAcct,
                        receiptInvoiceAddress: this.customerVo.receiptInvoiceAddress,
                        receiptInvoicePerson: this.customerVo.receiptInvoicePerson,
                        receiptInvoiceTel: this.customerVo.receiptInvoiceTel
                    };
                    this.$http({
                        url: this.$adornUrl("/bas/client/basCustomer/saveInvoiceTitle"),
                        method: "post",
                        data
                    }).then(({ data }) => {
                        if (data.code === "C0000") {
                          //  this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                            this.handlerSubmit()
                        } else {
                            let obj = {'receiptInvoiceAddress': '收票地址', 'receiptInvoicePerson': '收票联系人', 'receiptInvoiceTel': '收票联系电话'}
                            let message = data.message
                            for (const key in obj) {
                                if(data.message && data.message.indexOf(key) != -1) {
                                    message = `${obj[key]}值不能为空！`
                                    this.$message({type: 'error', message: message, offset: 380, grouping: true})
                                    return;
                                }
                                this.load.btnLoading2=false
                            }
                        }
                    });
                }
            })
        }, 
        //返回
        backListPage(){
            window.history.back()
        }       
    },
    created(){
        this.detailData=JSON.parse(window.sessionStorage.getItem('detailData'))||{}
        this.tableData = this.detailData.drawInvoiceEntryVos || [];
        this.dataForm = this.detailData.result || {};
        this.customerVo = this.detailData.customerVo || {};
    },
    activated(){
        let query = this.$route.query || {}
        this.routeQuery = Object.keys(query).length ? query : this.routeQuery
        if (
        typeof this.routeQuery.cache === "string"
            ? JSON.parse(this.routeQuery.cache)
            : this.routeQuery.cache
        ) {
            return false
        } else {
            this.routeQuery.cache = true
        }
        this.detailData=JSON.parse(window.sessionStorage.getItem('detailData'))||{}
        this.tableData = this.detailData.drawInvoiceEntryVos || [];
        this.dataForm = this.detailData.result || {};
        this.customerVo = this.detailData.customerVo || {};
    },
    beforeUnmount(){
        window.sessionStorage.removeItem('detailData')
    },
}
</script>

<style lang="scss">
.invoice-add{
    position: relative;
    padding:40px 0 20px 0;
    text-align: left;
    color: #000000;
    .el-form-item__label{
        color: #000000;
    }
    .el-table th.must>.cell:after {
	    content: ' *';
	    color: #ff1818;
    }
    h3{
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 40px;
    }
    .billingMoney{
        padding-bottom: 40px;
        margin-bottom: 40px;
        border-bottom: 1px solid #f0f2f5;
        .el-col.el-col-8{
            div{
                font-size: 14px;
                margin-bottom: 5px;
            }
            p{
                font-size: 36px;
                color: #F87243;
                font-weight: 500;
                font-family: DIN_Condensed_Bold;
                span{
                    font-size: 14px;
                }
            }
        }
    }
    .invoice-herder{
        border-bottom: 1px solid #f0f2f5;
        margin-bottom: 40px;
        .supplierName{
            width: 100%;
            display: flex;
            padding: 0 0 20px;
            border-bottom: 1px solid #F0F2F5;
            line-height: 24px;              
            .supplier{
                padding: 5px 4px;
                height: 24px;
                line-height: 14px;
                border-radius: 4px;
                background-color: #F0F2F5;
                span{
                    color: #FE2424;
                }
            }
            p{
                font-size: 22px;
                font-weight: bold; 
                margin-left: 20px;                   
            }
            .name{
                margin-left: 20px;
                font-size: 14px;
                color: #F87243;
            }
        }
        .el-col{
            margin-bottom: 20px;
        }
        .receiptInvoiceTela{
            position: relative;
            width: 50%;
            .el-form-item__content::after{
                content: '';
                position: absolute;
                right: 0;
                width: 1px;
                height: 20px;
                background-color: #B5B5B5;
            }
            .el-input__wrapper{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }
        .receiptInvoiceTelb{
            width: 50%;
            label{
                display: none;
            }
            .el-form-item__content{
                margin-top: 37px;
            }
            .el-input__wrapper{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
    }
    .billingMoney-table{
        .title{
            display: flex;
            justify-content: space-between;
            margin-bottom: 17px;
            h3{
                margin: 0;
            }
        }
        .el-table__footer-wrapper{
            td{
                background-color: #F2f7ff;
            }
        }
    }
    .footers {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #F0F2F5;
        text-align: center;
    }
}
</style>